<p-slider
  #model="ngModel"
  appReadOnly
  [ignoreReadOnly]="ignoreReadOnly"
  [name]="name"
  [(ngModel)]="value"
  [min]="min"
  [max]="max"
  [step]="step"
  (onSlideEnd)="onSlideEnd()"
  (onChange)="onSlideChange($event)"
></p-slider>
